import axios from 'axios';

export function initInfluencerStorefront() {
    // Initialize the store for influencer selection data and elements
    window.fusionINF = {
        // TODO: Register default state and elements as needed
    }

    // Check if there are query params that signal influencer storefront options/display on the account page
    const searchParams = window.location.search;
    const paramArray = searchParams.split("-");

    // Default check for insufficient query params
    if (!paramArray || paramArray.length < 2) {
        showDefaultAccountContent();
        return; // Exit if conditions are not met
    }

    // Handle influencer lists view
    if (paramArray[0] === "?view=inflists" && isValidParam(paramArray[1])) {
        showInfluencerListView();
    }
    // Handle influencer settings view
    else if (paramArray[0] === "?view=infsettings" && isValidParam(paramArray[1])) {
        showInfluencerSettingsView();
    }
}

const isValidParam = (param) => typeof param === "string" && param;

const showDefaultAccountContent = () => {
    const defaultAccountContent = document.getElementById('accountNonInf');
    if (defaultAccountContent) {
        defaultAccountContent.classList.add('show-default-account-content');
    }
}


const showInfluencerListView = () => {
    const infListContent = document.getElementById("accountInfListContent");
    const defaultOverview = document.querySelector('.account-overview');
    const defaultTitle = document.querySelector('.account__content__title');

    if (infListContent) {
        infListContent.classList.add('inf-settings-show');
        infListContent.classList.remove('hide-non-inf');
        defaultTitle.classList.add('inf-account-content-hidden');
        defaultOverview.classList.add("inf-account-content-hidden");
    } else {
        // TODO: add error logging here
    }
}

const showInfluencerSettingsView = () => {
    const infSettingsContent = document.getElementById("accountInfSettingsView");
    const defaultOverview = document.querySelector('.account-overview');
    const defaultTitle = document.querySelector('.account__content__title');

    if (infSettingsContent) {
        infSettingsContent.classList.add('inf-settings-show');
        infSettingsContent.classList.remove('hide-non-inf');
        defaultTitle.classList.add('inf-account-content-hidden');
        defaultOverview.classList.add("inf-account-content-hidden");
    } else {
        // TODO: add error logging here
    }
}

document.addEventListener("infAddNewProduct", (e) => {
    Alpine.store("infSelector").addProduct(e);
});

document.addEventListener("infRemoveItemFromSelector", (e) => {
    Alpine.store("infSelector").removeProduct(e);
});

const updateProductHandles = (data) => {
    const updatedHandles = data.listProductsJson.map((product) => product.handle);
    data.listProducts = updatedHandles;
    delete data["listProductsJson"];
    return data;
};

const makeAxiosPostRequest = (endpoint, payload, successCallback, errorCallback) => {
    axios.post(endpoint, payload)
        .then(successCallback)
        .catch(errorCallback);
};

const endpoints = {
    updateTest: "https://shark-app-xv79m.ondigitalocean.app/updateTest",
    productsByHandles: "https://shark-app-xv79m.ondigitalocean.app/products-by-handles",
    saveNewListName: "https://shark-app-xv79m.ondigitalocean.app/saveNewListName",
    deleteListFromAccount: "https://shark-app-xv79m.ondigitalocean.app/deleteListFromAccount",
    updateObjectMedia: "https://shark-app-xv79m.ondigitalocean.app/updateObjectMedia",
    updateAccountDetails: "https://shark-app-xv79m.ondigitalocean.app/updateAccountDetails",
    createNewMetaobjectRecord: "https://shark-app-xv79m.ondigitalocean.app/createNewMetaobjectRecord",
};

document.addEventListener("infCreateNewList", (data) => {
    const bodyElm = document.getElementById("FusionFrameworkInit");
    bodyElm.classList.add("fusion__content-loading-full");

    // Make a POST request using axios
    const endpoint = "https://shark-app-xv79m.ondigitalocean.app/newItemListEntry";
    axios
        .post(endpoint, data.detail)
        .then((res) => {
            let formattedData = res.data;
            formattedData["listProductsJson"] = [];
            localStorage.setItem("INF_SELECTION", JSON.stringify(formattedData));
            localStorage.setItem("INF_STATUS", true);
            setTimeout(() => {
                window.location = "https://www.buffbunny.com";
            }, 1000);
        })
        .catch(function (error) {
            console.error("Error:", error);
            alert("Error on list creation");
        });
});

document.addEventListener("infSaveAndComplete", (e) => {
    const bodyElm = document.getElementById("FusionFrameworkInit");
    bodyElm.classList.add("fusion__content-loading-full");

    const rawINFData = Alpine.raw(Alpine.store("infSelector").activeList);
    const gid = localStorage.getItem("INF_META_GID");
    const payload = {
        listProducts: rawINFData.listProducts,
        metaObjectGID: gid,
        listId: rawINFData.listId,
    };

    makeAxiosPostRequest(endpoints.updateTest, payload,
        (res) => {
            localStorage.setItem("INF_STATUS", "false");
            localStorage.setItem("INF_SELECTION", "");
            const metaGID = localStorage.getItem('INF_META_GID')
            setTimeout(() => {
                window.location = `/account?view=inflists-${metaGID}`;
            }, 3000);
        },
        (error) => {
            console.error("Error:", error);
            alert("Error on list creation");
        }
    );
});

document.addEventListener("infSortUpdateSave", (e) => {
    const bodyElm = document.getElementById("FusionFrameworkInit");
    bodyElm.classList.add("fusion__content-loading-full");

    // const rawINFData = Alpine.raw(Alpine.store("infSelector").activeList);
    const gid = localStorage.getItem("INF_META_GID");
    const payload = {
        listProducts: e.detail.listProducts,
        metaObjectGID: gid,
        listId: e.detail.listId,
    };

    makeAxiosPostRequest(endpoints.updateTest, payload,
        (res) => {
            if (res.data) {
                setTimeout(() => {
                    alert('Updated Successfully!')
                    bodyElm.classList.remove("fusion__content-loading-full");
                }, 400);
            }
        },
        (error) => {
            console.error("Error:", error);
            alert("Error on list creation");
        }
    );
});






document.addEventListener("infEditListItems", (e) => {
    const data = e.detail;

    let parsedObj = JSON.parse(data.productList);
    localStorage.setItem("INF_META_GID", data.metaObjectGID);

    const payload = { handles: parsedObj.listProducts };

    const bodyElm = document.getElementById("FusionFrameworkInit");
    bodyElm.classList.add("fusion__content-loading-full");

    makeAxiosPostRequest(endpoints.productsByHandles, payload,
        (res) => {
            parsedObj['listProductsJson'] = res.data;
            localStorage.setItem("INF_STATUS", "true");
            localStorage.setItem("INF_SELECTION", JSON.stringify(parsedObj));

            setTimeout(() => {
                window.location = "https://www.buffbunny.com";
            }, 1000);
        },
        (error) => {
            console.error("Error:", error);
            alert("Error on list creation");
        }
    );

    localStorage.setItem("INF_SELECTION", data.productList);
});

const escapeHTML = (str) => str.replace(/[&<>"']/g, (match) => {
    const escape = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
    };
    return escape[match];
});

const unescapeHTML = (escapedStr) => {
    const htmlEntities = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
    };
    return escapedStr.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, (match) => htmlEntities[match]);
};

const changeListName = (currentName) => {
    return new Promise((resolve, reject) => {
        let newName = prompt("Please enter the new name for the list", unescapeHTML(currentName));

        if (newName && newName.trim() !== "") {
            resolve(escapeHTML(newName.trim()));
        } else {
            reject("List name change was cancelled or invalid input was provided.");
        }
    });
}

document.addEventListener("infEditListName", (e) => {
    const data = e.detail;
    let currentName = JSON.parse(e.detail.productList);

    changeListName(currentName.listName)
        .then((newName) => {
            const bodyElm = document.getElementById("FusionFrameworkInit");
            bodyElm.classList.add("fusion__content-loading-full");
            const metaGID = localStorage.getItem('INF_META_GID')

            const payload = {
                listId: data.listId,
                metaObjectGID: metaGID,
                updatedName: newName,
            };
            makeAxiosPostRequest(endpoints.saveNewListName, payload,
                (res) => {
                    const titleElm = document.getElementById(`listTitle-${data.listId}`);
                    if (titleElm) {
                        titleElm.innerHTML = newName;
                        setTimeout(() => {
                            bodyElm.classList.remove("fusion__content-loading-full");
                        }, 300);
                    } else {
                        alert("Error removing element");
                        location.reload();
                    }
                },
                (error) => {
                    console.error("Error:", error);
                    alert("Error on list creation");
                }
            );
        })
        .catch((error) => {
            console.log(error);
        });
});



document.addEventListener("infDeleteList", (e) => {
    const data = e.detail;
    const bodyElm = document.getElementById("FusionFrameworkInit");
    bodyElm.classList.add("fusion__content-loading-full");

    makeAxiosPostRequest(endpoints.deleteListFromAccount, data,
        (res) => {
            const elmToRemove = document.getElementById(data.listId);
            console.log("Element to remove:", elmToRemove);
            if (elmToRemove) {
                elmToRemove.remove();
                setTimeout(() => {
                    bodyElm.classList.remove("fusion__content-loading-full");
                }, 500);
            } else {
                alert("Error removing element");
                location.reload();
            }
        },
        (error) => {
            console.error("Error:", error);
            alert("Error on list creation");
        }
    );
});

const updateProfileMedia = (fieldKey, fieldValue, metaObjectGID) => {
    const data = { fieldKey, fieldValue, metaObjectGID };
    makeAxiosPostRequest(endpoints.updateObjectMedia, data,
        (res) => {
            console.log("Update success", res.data);
        },
        (error) => {
            console.error("Error:", error);
            alert("Error on media update");
        }
    );
};

document.addEventListener("infSetProfileMedia", (e) => {
    updateProfileMedia("profile_photo", e.detail.resourceGID, e.detail.metaobjectGID);
});

document.addEventListener("infSetProfileBanner", (e) => {
    updateProfileMedia("background_photo", e.detail.resourceGID, e.detail.metaobjectGID);
});


// Ensure escapeHTML is defined
function escapeHTMLInfo(str) {
    return str?.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

document.addEventListener("infUpdateInfo", (e) => {
    const formData = {
        storefront_page_title: escapeHTMLInfo(document.getElementById("storefront_page_title")?.value),
        storefront_description: escapeHTMLInfo(document.getElementById("storefront_description")?.value),
        instagram_url: escapeHTMLInfo(document.getElementById("instagram_url")?.value),
        twitter_url: escapeHTMLInfo(document.getElementById("twitter_url")?.value),
        facebook_url: escapeHTMLInfo(document.getElementById("facebook_url")?.value),
        tik_tok_url: escapeHTMLInfo(document.getElementById("tik_tok_url")?.value),
    };

    const data = { metaObjectGID: e.detail.metaObjectGID, ...formData };

    const bodyElm = document.getElementById("FusionFrameworkInit");
    bodyElm.classList.add("fusion__content-loading-full");

    makeAxiosPostRequest(endpoints.updateAccountDetails, data,
        (res) => {
            setTimeout(() => {
                location.reload();
            }, 5000);
        },
        (error) => {
            console.error("Error:", error);
            alert("Error on account update");
        }
    );
});

document.addEventListener("infActivateAccount", (e) => {
    const data = {
        customer_account_first_name: e.detail.customerFirstName,
        customer_account_last_name: e.detail.customerLastName,
        shopify_customer_account_id: e.detail.shopify_customer_account_id,
    };

    const bodyElm = document.getElementById("FusionFrameworkInit");
    bodyElm.classList.add("fusion__content-loading-full");

    makeAxiosPostRequest(endpoints.createNewMetaobjectRecord, data,
        (res) => {
            localStorage.setItem("INF_META_GID", res.data.data.metaobjectCreate.metaobject.id);

            setTimeout(() => {
                location.reload();
            }, 5000);
        },
        (error) => {
            console.error("Error:", error);
            alert("Error on account activation");
        }
    );
});
